const faqAccordion = document.getElementsByClassName('jobs-list');
if (faqAccordion) {

	const allJobs = document.querySelectorAll('.job-card');

	allJobs.forEach(job => {
		job.querySelector('.job-card__head').addEventListener('click', function () {
			const parent = this.parentElement;
			if (parent.classList.contains('open')) {
				parent.classList.remove('open');
			} else {
				allJobs.forEach(job => {
					job.classList.remove('open');
				});
				parent.classList.add('open');
			}
		});
	});
}
